<template>
  <div>
    <div class="search-container navbar-text d-none d-xl-block">
      <div class="search-form">
        <div class="container">
          <div class="form-wrapper">
            <form>
              <input
                type="text"
                name="search"
                autocomplete="off"
                class="form-control"
                :placeholder="$t('app.searchPlaceholder')"
                @input="search"
                @click="resetSelectedResult"
                @keydown.enter.prevent="onEnter"
                @keyup.down="onDown"
                @keyup.up="onUp"
                v-model="query"
                ref="input">
                <i class="icon-search-1" v-if="query === null || query === ''"></i>
                <i class="icon-close" @click="closeForm" v-else></i>
            </form>
          </div>
          <header-search-results-new v-if="results && results.length" :results="results" :query="query" :selectedResult="selectedResult"></header-search-results-new>
        </div>
      </div>
    </div>
    <div class="search-container navbar-text d-block d-xl-none">
      <label @click="toggleForm">
        <i class="icon-search-1 text-green"></i>
      </label>
      <div :class="formClass" v-if="show">
        <div class="form-wrapper">
          <form class="form-inline">
            <input
              type="text"
              name="search"
              autocomplete="off"
              class="form-control"
              :placeholder="$t('app.searchPlaceholder')"
              @input="search"
              @click="resetSelectedResult"
              @keydown.enter.prevent="onEnter"
              @keyup.down="onDown"
              @keyup.up="onUp"
              v-model="query"
              ref="input">
          </form>
          <label @click="toggleForm">
            <i class="icon-close"></i>
          </label>
        </div>
        <header-search-results-new v-if="results && results.length" :results="results" :query="query" :selectedResult="selectedResult"></header-search-results-new>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'
import Xhr from '@Core/xhr'
import throttle from 'lodash/throttle'
import HeaderSearchResultsNew from './HeaderSearchResultsNew.vue'

export default {
  components: {
    HeaderSearchResultsNew
  },

  props: {
    src: {
      default: '/search'
    }
  },

  data () {
    return {
      show: false,
      query: null,
      results: null,
      selectedResult: null
    }
  },

  computed: {
    formClass () {
      return 'search-form' + (this.show ? ' show' : '')
    }
  },

  created () {
    this.query = this.getQueryString()
  },

  methods: {
    getQueryString () {
      let params = qs.parse(location.search.replace('?', ''))
      return (params.query && params.query.length) ? params.query : null
    },

    closeForm () {
      this.show = false
      this.results = null
      this.query = this.getQueryString()
    },

    toggleForm () {
      this.show = !this.show

      // Focus field if shown else clear results
      if (this.show) {
        Vue.nextTick(() => this.$refs.input.focus())
      } else {
        this.results = null
        this.query = this.getQueryString()
      }
    },

    search: throttle(async function () {
      this.resetSelectedResult()

      this.results = this.query.length >= 2
        ? await this.getResults()
        : null
    }, 1000),

    getResults () {
      return new Xhr({ query: this.query }).post(this.src)
    },

    resetSelectedResult () {
      this.selectedResult = null
    },

    onEnter () {
      if (this.selectedResult === null) {
        window.location = window.App.url + '/'+App.vue.$options.lang.$t('routes.category')+'?page=1&query=' + this.query
      } else {
        if (this.selectedResult > (this.results[0].results.length + this.results[1].results.length - 1)) {
          window.location = window.App.url + this.results[2].results[this.selectedResult - this.results[1].results.length - this.results[0].results.length].link
        }
        else if (this.selectedResult > (this.results[0].results.length - 1)) {
          window.location = window.App.url + this.results[1].results[this.selectedResult - this.results[0].results.length].link
        } else {
          window.location = window.App.url + this.results[0].results[this.selectedResult].link
        }
      }
    },

    onDown () {
      if (((this.results[0].results.length + this.results[1].results.length + this.results[2].results.length) - 1 > this.selectedResult) || this.selectedResult === null) {
        this.selectedResult = this.selectedResult === null
          ? 0
          : this.selectedResult + 1
      }
    },

    onUp () {
      if (this.selectedResult !== null) {
        this.selectedResult = this.selectedResult === 0
          ? null
          : this.selectedResult - 1
      }
    }
  }
}
</script>
